<template>
    <div class="navbar">
        <hamburger id="hamburger-container" :is-active="sidebar.opened" class="hamburger-container" @toggleClick="toggleSideBar" />
        <breadcrumb id="breadcrumb-container" class="breadcrumb-container" />
        <div v-once class="right-menu">
            <error-log class="errLog-container right-menu-item hover-effect" />
            <!-- <el-tooltip class="item" effect="dark" content="刷新页面" placement="bottom" :open-delay="200">
                <div class="right-menu-item hover-effect" @click="refreshBrowser">
                    <i class="el-icon-refresh" />
                </div>
            </el-tooltip> -->
            <div class="right-menu-item hover-effect" @click="$open('/message')">
                <el-badge :value="messageNoReadNum" :max="99" :hidden="messageNoReadNum == 0" type="danger">
                    <i class="el-icon-bell" />
                </el-badge>
            </div>
            <el-dropdown class="avatar-container right-menu-item hover-effect" trigger="click">
                <div class="avatar-wrapper">
                    <div class="user-avatar"><img v-lazy="{src: $headerImgUrl(avatar), error: '/static/img/header-img.jpg'}"></div>
                    <span class="user-name">{{ name }}</span>
                    <i class="el-icon-caret-bottom" style="font-size: 16px;" />
                </div>
                <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item @click.native="$router.push('/')">返回首页</el-dropdown-item>
                    <el-dropdown-item @click.native="goRouter('/user')">个人信息</el-dropdown-item>
                    <el-dropdown-item @click.native="logout">退出登录</el-dropdown-item>
                </el-dropdown-menu>
            </el-dropdown>
        </div>
    </div>
</template>

<script>
import Breadcrumb from "@/components/Breadcrumb";
import ErrorLog from '@/components/ErrorLog';
import Hamburger from "@/components/Hamburger";
import { mapGetters } from "vuex";

export default {
    components: {
        Breadcrumb,
        Hamburger,
        ErrorLog
    },
    computed: {
        ...mapGetters(["name", "sidebar", "avatar", "device", "messageNoReadNum"])
    },
    methods: {
        toggleSideBar() {
            this.$store.dispatch("ToggleSideBar");
        },
        async logout() {
            await this.$store.dispatch("LogOut");
            this.$router.push('/');
        },
        goRouter(url) {
            this.$router.push(url);
        },
        refreshBrowser() {
            localStorage.clear();
            window.location.reload(true);
        }
    }
};
</script>

<style lang="scss" scoped>
.navbar {
    height: 50px;
    overflow: hidden;
    position: relative;
    background: #fff;
    box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);
    .hamburger-container {
        line-height: 46px;
        height: 100%;
        float: left;
        cursor: pointer;
        transition: background 0.3s;
        -webkit-tap-highlight-color: transparent;
        &:hover {
            background: rgba(0, 0, 0, 0.025);
        }
    }

    .breadcrumb-container {
        float: left;
    }

    .errLog-container {
        display: inline-block;
        vertical-align: top;
    }
    .right-menu {
        float: right;
        height: 100%;
        .right-menu-item {
            display: inline-flex;
            align-items: center;
            justify-content: center;
            padding: 0 10px;
            height: 100%;
            color: #5a5e66;
            vertical-align: text-bottom;
            &:hover {
                color: #409EFF;
            }

            [class^="el-icon-"] {
                font-size: 22px;
            }
            &.hover-effect {
                cursor: pointer;
                transition: background 0.3s;
                &:hover {
                    background: rgba(0, 0, 0, 0.025);
                }
            }
        }

        .avatar-container {
            margin-right: 15px;
            .user-name {
                font-size: 14px;
                margin: 0 0 0 10px;
            }
            .avatar-wrapper {
                display: flex;
                align-items: center;
                .user-avatar {
                    cursor: pointer;
                    width: 35px;
                    height: 35px;
                    border-radius: 50%;
                    border: 1px solid #f1f1f1;
                    overflow: hidden;
                    font-size: 0;
                    img {
                        height: 100%;
                        width: 100%;
                        object-fit: cover;
                        vertical-align: top;
                    }
                }
                .el-icon-caret-bottom {
                    cursor: pointer;
                }
            }
        }
    }
}
</style>
